import Fuse from 'fuse-js-latest'
// import clonedeep from 'lodash.clonedeep'

const SEARCH_OPTIONS = {
  shouldSort: true,
  tokenize: true,
  threshold: 0.3,
  location: 0,
  distance: 50,
  includeMatches: true,
  maxPatternLength: 32,
  minMatchCharLength: 1,
  keys: [
    "title",
    "description",
  ]
};

export default {
  data: () => ({
    search_string: '',
    search_result: null,
    search_cache: [],
    search_primary_key: 'title',
    search_result_as_object: true,
    search_format_matches: true,
  }),
  created() {
    this.makeSearchCache();
    this.setUpFuse();
  },
  watch: {
    search_string( query ) {
      // DEBOUNCE
      if ( query ) {
        this.querySearch( query, (res) => {
          this.search_result = res;
        })
      } else {
        this.search_result = null;
      }
    }
  },
  methods: {
    setUpFuse(
      option_override = {},
      search_result_as_object = true,
      search_format_matches = true
    ) {
      this.fuse = new Fuse(
        this.search_cache,
        Object.assign({}, SEARCH_OPTIONS, option_override)
      );
      if ( option_override.keys && option_override.keys.length > 0 ) {
        this.search_primary_key = option_override.keys[0]
      }
      this.search_result_as_object = search_result_as_object;
      this.search_format_matches = search_format_matches;
    },
    // Overwrite in importing component
    /*
    makeSearchCache() {
      this.search_cache = ...;
    },
    */
    querySearch(query_string, cb) {
      var results = this.fuse.search(query_string);

      results = results.map(result => {
        let matches = result.matches.map(match => match.indices);
        matches = [].concat.apply([], matches);

        return {
          ...result.item,
          matched_text: this.search_format_matches
            ? this.formatMatches( result.item[ this.search_primary_key ] || [], matches )
            : null
        };
      });

      if ( this.search_result_as_object ) {
        let results_as_object = {};
        results.map(result => {
          results_as_object[ result.$id ] = result;
        })
        results = results_as_object
      }

      // console.log("[search] results", results);
      cb(results);
    },
    formatMatches( text, matches ) {
      /* Build a formatted string */
      let result = [];
      var pair = matches.shift()
      for ( var i = 0; i < text.length; i++ ) {
        var char = text.charAt(i)
        if ( pair && i === pair[0] ) {
          result.push('<strong>')
        }
        if ( char === '<' ) {
          result.push('<span class="no-style">')
        } else if ( char === '>' ) {
          result.push('</span>')
        } else {
          result.push(char)
        }
        if ( pair && i === pair[1] ) {
          result.push('</strong>')
          pair = matches.shift()
        }
      }
      return result.join('');
    },
  },
}
